import { call, put, select, takeLatest } from "redux-saga/effects";
import { FETCH_QUESTION_PROMPTER_REQUEST, fetchQuestionPrompterFailure, fetchQuestionPrompterSuccess } from "../actions/questionsPrompterDataActions";
import { fetchAccountBUUseCaseQuestions } from "../../../services/accIqService";


// Worker Saga
function* fetchQuestionsPrompterDataSaga() {
  try {
    const payload = yield select(
      (state) => state?.questionsPrompterDataReducer?.payload
    );
    const { accountName, clientName, activeUnit, title } = payload;
    const data = yield call(
      fetchAccountBUUseCaseQuestions,
      accountName,
      clientName,
      activeUnit,
      title,
      true
    );
    yield put(fetchQuestionPrompterSuccess(data));
  } catch (error) {
    yield put(fetchQuestionPrompterFailure(error.message));
  }
}

// Watcher Saga
export function* watchFetchQuestionsPrompterData() {
  yield takeLatest(FETCH_QUESTION_PROMPTER_REQUEST, fetchQuestionsPrompterDataSaga);
}
